import lodash from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormGroup } from '@material-ui/core';
import SearchBar from '../../../../components/table/SearchBar';
import { SET_LEAD_PAYMENT_APPROVAL_DATA, GET_LEAD_PAYMENT_APPROVAL_DATA } from '../constants';

class TableFilters extends Component {
    refreshData = lodash.debounce((isCount) => {
        const { dispatch } = this.props;

        dispatch({ type: GET_LEAD_PAYMENT_APPROVAL_DATA, isCount });
    }, 500, { leading: true, trailing: false });

    handleSearchByVrm = (value) => {
        const { dispatch } = this.props;

        dispatch({
            type: SET_LEAD_PAYMENT_APPROVAL_DATA,
            payload: {
                'filters.vrm': value,
            },
            refreshPaths: ['filters'],
        });

        if (value.length === 0 || value.length >= 3) {
            this.refreshData(true);
        }
    };

    render() {
        const { filters } = this.props;
        return (
            <Fragment>
                <FormGroup row>
                    <SearchBar
                        onClickRefresh={() => this.refreshData()}
                        onSearch={this.handleSearchByVrm}
                        searchPlaceholder="Search by VRM"
                        searchStyle={{ minWidth: 200 }}
                        searchValue={filters.vrm}
                    />
                </FormGroup>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    filters: state.Leads.LeadPaymentApproval.filters,
});

export default connect(mapStateToProps)(TableFilters);



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/components/TableFilters.js